import { Skeleton, SxProps, Theme } from "@mui/material"
import { FC } from "react"

interface SkeletonWrapperProps {
  height?: number | string
  width?: number | string
  animation?: "pulse" | "wave" | false
  variant?: "text" | "rectangular" | "rounded" | "circular"
  sxProps?: SxProps<Theme>
}

export const SkeletonWrapper: FC<SkeletonWrapperProps> = ({
  variant = "rectangular",
  animation = "wave",
  sxProps,
  height,
  width,
}) => {
  return (
    <Skeleton
      height={height}
      width={width}
      variant={variant}
      animation={animation}
      sx={{ ...sxProps }}
    />
  )
}
